if(document.querySelector('body').classList.contains('template-suffix-subscription')){

}else{
  if(Object.keys(apConfig).length > 0 && document.querySelector('.cart-subtotal') != null){
    const cartTotal = document.querySelector('.cart-subtotal').dataset.amount;
    const apConfig = {
      priceSelector: '.cart-footer__total-price',
      locale: 'en_US',
      currency: 'USD',
      afterpayLogoColor: 'white',
      showUpperLimit: false,
      amount: cartTotal,
      minMaxThreshold: {
        min: 100,
        max: 100000,
      },
    };
    new presentAfterpay(apConfig).init();
  }
  if(apConfig != undefined){
    if(Object.keys(apConfig).length > 0 && document.querySelector('body').classList.contains('template-cart') && document.querySelector('.cart-subtotal') != null){
      const cartTotal = document.querySelector('.cart-subtotal').dataset.amount;
      const apConfig = {
        priceSelector: '.cart-policies',
        locale: 'en_US',
        currency: 'USD',
        afterpayLogoColor: 'white',
        showUpperLimit: false,
        amount: cartTotal,
        minMaxThreshold: {
          min: 100,
          max: 100000,
        },
      };
      new presentAfterpay(apConfig).init();
    }
    window.onload = function() {
      if(Object.keys(apConfig).length > 0 && document.querySelector('body').classList.contains('template-product')){
        const ap = new presentAfterpay(apConfig).init();
        // apConfig.priceSelector = '.main-mobile-price-selector';
        // new presentAfterpay(apConfig).init();
        // var price = document.querySelector('product-form.sticky-content-container .price');
        // var config = {childList: true, subtree: true };
      }  
    }
  }
}

async function ensureSingleMembership() {
  try {
    // Fetch current cart
    const cart = await fetch('/cart.js').then(res => res.json());

    // Find all line items with handle 'membership'
    const membershipItems = cart.items.filter(item => item.handle === 'inveterate-subscription-b387add1');
    if (membershipItems.length > 0) {
      document.querySelectorAll('.product-membership-widget').forEach(w => w.classList.add('added'));
      // Keep only the first item, and make sure its quantity = 1
      const [keepItem, ...duplicates] = membershipItems;

      // Prepare all updates
      const updates = {};

      if(membershipItems.length == 1 && membershipItems[0].quantity == 1){
        return;
      }

      // Set the first membership item to quantity 1
      updates[keepItem.key] = 1;

      // Set all duplicates' quantities to 0 (remove them)
      duplicates.forEach(item => {
        updates[item.key] = 0;
      });

      // Also check if total membership quantity > 1 in the same line (edge case)
      if (keepItem.quantity > 1) {
        updates[keepItem.key] = 1;
      }
    
      // If any changes are needed, apply them
      if (Object.keys(updates).length > 0) {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        }).then(res => res.json()).then(res => {
          document.querySelector('cart-drawer').cartRefreshHandler();
        });
      }
    }else{
      document.querySelectorAll('.product-membership-widget').forEach(w => w.classList.remove('added'));
    }
  } catch (error) {
    console.error('Error ensuring single membership:', error);
  }
}

async function trackPackAdded(data) {
  let itemsArr = [];
  if(!data.items){
    itemsArr.push(data)
  }else{
    itemsArr = data.items;
  }
  const items = await Promise.all(itemsArr.map(async (i) => {
      if (i.handle == "curated-merge") {
          const properties = JSON.parse(i.properties.__details);

          return {
              "URL": properties.__link,
              "ProductID": i.product_id,
              "Quantity": i.quantity,
              "ImageURL": properties.__image,
              "Brand": "INTO THE AM",
              "Product Name": properties.__title,
              "Variant Name": properties.__pack_options.split('/').join(' / '),
              "$value": i.final_line_price / 100,
              "price": properties.__total,
              "discount": i.total_discount / 100,
              "final_price": i.final_price / 100
          };
      } else {
          const response = await fetch(`/products/${i.handle}.js`);
          const productData = await response.json();

          const variant = productData.variants.find(v => v.id == i.variant_id);

          const tp = variant.compare_at_price != null
              ? variant.compare_at_price
              : variant.price;

          console.log(variant);

          return {
              "URL": i.url,
              "ProductID": i.product_id,
              "Quantity": i.quantity,
              "ImageURL": i.image,
              "Brand": "INTO THE AM",
              "Product Name": i.product_title,
              "Variant Name": i.variant_title?.split('/').join(' / ') || "",
              "$value": i.final_line_price / 100,
              "price": (tp * i.quantity) / 100,
              "discount": i.total_discount / 100,
              "final_price": i.final_price / 100
          };
      }
  }));
  // console.log(items);
  if(window.customerEmail){
    // customerEmail must belong to the current shopper.
    return await window.klaviyo.identify({
      email: window.customerEmail
    }).then(async function () {
      return await window.klaviyo.track("Added to Cart - New", {
        Items: items,
        ...items[0]
      });
    });
  }
}

window.cartAddEventData = null;
window.shouldTransformElevar = false;

async function trackCartEvent(){
  const response = await fetch(`/cart.js`);
  const cartData = await response.json();
  if(cartData.item_count == 0){
    return;
  }

  const items = await Promise.all(cartData.items.map(async (i) => {
    if (i.handle == "curated-merge") {
        const properties = JSON.parse(i.properties.__details);

        return {
            "URL": properties.__link,
            "ProductID": i.product_id,
            "Quantity": i.quantity,
            "ImageURL": properties.__image,
            "Brand": "INTO THE AM",
            "Product Name": properties.__title,
            "Variant Name": properties.__pack_options.split('/').join(' / '),
            "$value": i.final_line_price / 100,
            "price": properties.__total,
            "discount": i.total_discount / 100,
            "final_price": i.final_price / 100
        };
    } else {
        const response = await fetch(`/products/${i.handle}.js`);
        const productData = await response.json();
        const variant = productData.variants.find(v => v.id == i.variant_id);
        const tp = variant.compare_at_price != null
            ? variant.compare_at_price
            : variant.price;

        return {
            "URL": i.url,
            "ProductID": i.product_id,
            "Quantity": i.quantity,
            "ImageURL": i.image,
            "Brand": "INTO THE AM",
            "Product Name": i.product_title,
            "Variant Name": i.variant_title?.split('/').join(' / ') || "",
            "$value": i.final_line_price / 100,
            "price": (tp * i.quantity) / 100,
            "discount": i.total_discount / 100,
            "final_price": i.final_price / 100
        };
    }
  }));

  if(window.customerEmail){
    // customerEmail must belong to the current shopper.
    return await window.klaviyo.identify({
      email: window.customerEmail
    }).then(async function () {
      return await window.klaviyo.track("Added to Cart - New", {
        Items: items,
        $value: cartData.items_subtotal_price/100,
        CartURL: 'https://shopintotheamoutlet.com/cart',
        $event_id: `${cartData.token}-${Math.floor(Date.now() / 1000)}`
      });
    });
  }

  return await window.klaviyo.track("Added to Cart - New", {
    Items: items,
    $value: cartData.items_subtotal_price/100,
    CartURL: 'https://shopintotheamoutlet.com/cart',
    $event_id: `${cartData.token}-${Math.floor(Date.now() / 1000)}`
  });
}

document.addEventListener('on:cart:change', (event) => {
  setTimeout(function(){
    const res = trackCartEvent();
  });
});

document.addEventListener('on:cart:add', (event) => {
  window.cartAddEventData = event.detail.data;
  window.shouldTransformElevar = true;
  
  setTimeout(function(){
    ensureSingleMembership();
  }, 300);
  setTimeout(function(){
    // const res = trackPackAdded(event.detail.data);
    const res = trackCartEvent();
  }, 100);
});

window.ElevarTransformFn = eventData => {
  if (
    !window.shouldTransformElevar ||
    eventData.event !== "dl_add_to_cart"
  ) {
    return eventData;
  }
  const cartData = window.cartAddEventData;
  if (
    eventData.ecommerce?.add?.products &&
    Array.isArray(eventData.ecommerce.add.products) &&
    cartData?.items
  ) {
    eventData.ecommerce.add.products =
      eventData.ecommerce.add.products.map((item) => {
        if (item.product_id != "8357665275961") {
          return item;
        }

        const citem = cartData.items.find((i) => {
          return i.handle === "curated-merge";
        });

        if (!citem?.properties?.__details) {
          return item;
        }

        try {
          const rawDetails = citem.properties.__details;
          const properties = typeof rawDetails === "string"
            ? JSON.parse(rawDetails)
            : rawDetails;

          return {
            ...item,
            name: properties.__title,
            url: properties.__link
          };
        } catch (error) {
          console.error("Failed to parse curated product details:", error);
          return item;
        }
      });
  }

  window.shouldTransformElevar = false;
  window.cartAddEventData = null;

  return eventData;
};

document.addEventListener('on:cart-drawer:before-open', (event) => {
  document.querySelectorAll('.zero-price').forEach(el => {
    el.innerHTML = Shopify.formatMoney(0, window.theme.settings.moneyWithoutCurrencyFormat);
  });
  if(location.pathname == '/community/membership'){
    
  }else{
    ensureSingleMembership();
  }
});
document.addEventListener('on:cart-drawer:after-open', (event) => {
  window.dataLayer = window.dataLayer || [];
  dataLayer.push({
    event: 'slideout_cart',
    eventParameter:{
      event_trigger_type: 'slider_cart_open',
      event_trigger_value: true
    },
    custom_event_label: 'slider_cart_open',
    custom_event_value: true
  });
});